import { render, staticRenderFns } from "./DocsFilterToolbar.vue?vue&type=template&id=28bcb0fb&scoped=true"
import script from "./DocsFilterToolbar.vue?vue&type=script&lang=js"
export * from "./DocsFilterToolbar.vue?vue&type=script&lang=js"
import style0 from "./DocsFilterToolbar.vue?vue&type=style&index=0&id=28bcb0fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bcb0fb",
  null
  
)

export default component.exports